/* eslint-disable no-param-reassign */
/* eslint-disable */

import axios from "axios";
import { NotificationManager } from "react-notifications";

const customAxios = axios.create({
  baseURL: `${process.env.REACT_APP_Petra_API_ENDPOINT}`,
  timeout: 90000, // Set timeout to 90 seconds (1.5 minutes)
  // baseURL: `http://192.0.0.165:3018`,
});

const requestHandler = (config) => {
  const token = localStorage.getItem("token");
  const esriToken = localStorage.getItem("esriToken");
  if (token) {
    // eslint-disable-next-line dot-notation
    config.headers["access-token"] = token;
    config.headers["esri-token"] = esriToken;
  }
  return config;
};

const errorHandler = (error) => {
  if (error.code === 'ECONNABORTED') {
    NotificationManager.error("الخادم غير متوفر");
    return Promise.reject(new Error("Request timed out"));
  }

  if (error.response) {
    const { status } = error.response;
    
    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("userDetails");
      const { origin } = window.location;
      window.location.href = `${origin}/petraparcels/auth`;
    }

    if (status === 502 || error.message === "Network Error") {
      NotificationManager.error("الخادم غير متوفر");
      return Promise.reject(new Error("Stopped due to server unavailability"));
    }
  }

  return Promise.reject(error);
};

customAxios.interceptors.request.use(
  (config) => requestHandler(config),
  (error) => errorHandler(error)
);

customAxios.interceptors.response.use(null, (error) => errorHandler(error));

export default customAxios;
